var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("save-bar", [
    _c("div", [
      _c("h1", [_vm._v("Edit Third Party")]),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c("div", { staticClass: "input-container" }, [
            _c("div", { staticClass: "input-label" }, [_vm._v("Third Party:")]),
            _c(
              "div",
              { staticClass: "main-input" },
              [
                _c("input-component", {
                  attrs: { validationObj: _vm.$v.thirdParty.name },
                  model: {
                    value: _vm.$v.thirdParty.name.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.thirdParty.name, "$model", $$v)
                    },
                    expression: "$v.thirdParty.name.$model"
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }